import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
// import Button from "@material-ui/core/Button";
// import { IBooleanResponse } from "@common/IBooleanResponse";
import { Controller, UseFormMethods, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
// import { useFetch } from "@common/hooks/useFetch";
import { WORDPRESS_URL } from "@constants";
// import { sendOtp } from "../../ApiRoutes";
import {
    dateFormatRegex,
    maxYearValid,
    minYearValid,
    over18Valid,
    specialAlphaNumericRegex,
} from "@utils/formControls";
import { DateMask } from "@common/DateMask";
import { ICustomerDetailsForm } from "./CustomerDetailsForm";
import { CommunicationLanguageRadio } from "./CommunicationLanguageRadio";
import { useState } from "react";
import { getLanguage } from "@utils/changeLanguage";
import { PhoneNumberUtil } from "google-libphonenumber";
import PhoneInput, { CountryData } from "react-phone-input-2";
import "./phoneInputFiles/phoneInput.scss";
import gr from "./phoneInputFiles/lang/gr.json";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";
import { MenuItem } from "@material-ui/core";
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
// import { Loader } from "@common/handleErrorAndLoading/Loader";

interface IParams {
    formMethods: UseFormMethods<ICustomerDetailsForm>;
    // setNumberVerified(isVerified: boolean): void;
    // numberVerified: boolean;
    // emailVerified: boolean;
    portInNumbers: string[];
}

interface PermissionType {
    value: string;
    label: string;
}

const permissions: PermissionType[] = [
    { value: "YES", label: "yes" },
    { value: "NO", label: "no" },
];

const phoneUtil = PhoneNumberUtil.getInstance();

export const CustomerDetailsPersonalDetails = (props: IParams) => {
    const isAuthenticated = keycloakUtils.isAuthenticated();
    const { t } = useTranslation(["customerDetails", "validation", "portin"]);
    const { formMethods, portInNumbers } = props;
    // const { formMethods, setNumberVerified, numberVerified, emailVerified, portInNumbers } = props;
    // const verifyNumberTranslated: string = t("customerDetails:verifyNumber");
    // const verifyOTPTranslated: string = t("customerDetails:verifyOTP");
    // const [verifyNumberText, setVerifyNumberText] = useState<string>(verifyNumberTranslated);
    // const [showNumerOtpError, setShowNumerOtpError] = useState<boolean>(false);
    // const [showSendOtpError, setShowSendOtpError] = useState<boolean>(false);

    // const [OTP, setOTP] = useState<string>("");
    // const [_, { post }] = useFetch();
    const [isPhoneValid, setIsPhoneValid] = useState<boolean>(true);
    const { control, clearErrors, errors, register } = formMethods;
    // const { control, clearErrors, trigger, errors, register } = formMethods;
    const birthDate = useWatch<string>({ name: "birthDate", control: control });
    // const mobileNumber = useWatch<string>({ name: "mobileNumber", control: control });
    // const { executeRecaptcha } = useGoogleReCaptcha();
    // const [isValidateLoading, setIsValidateLoading] = useState<boolean>(false);

    const onMobileNumberChange = (phoneNumber: string) => {
        const number = phoneNumber;
        // setVerifyNumberText(verifyNumberTranslated);
        // setNumberVerified(false);
        // setShowNumerOtpError(false);
        // setShowSendOtpError(false);
        // setOTP("");
        if (portInNumbers.length && portInNumbers.includes(number)) {
            clearErrors("mobileNumber");
        }
    };

    // const onVerifyNumberButtonClick = async (resend: boolean) => {
    //     if (await trigger("mobileNumber")) {
    //         if (verifyNumberText === verifyNumberTranslated || resend) {
    //             if (!emailVerified) {
    //                 return;
    //             }

    //             if (resend) {
    //                 setOTP("");
    //                 setNumberVerified(false);
    //                 setShowNumerOtpError(false);
    //                 setShowSendOtpError(false);
    //             }

    //             try {
    //                 if (!resend) setIsValidateLoading(true);
    //                 await sendOtpFunction("MSISDN");
    //                 if (!resend) setIsValidateLoading(false);
    //             } catch (error: any) {
    //                 console.error("sendOtpFunction OTP verification failed:", error);
    //                 if (!resend) {
    //                     setVerifyNumberText(verifyNumberTranslated);
    //                     setIsValidateLoading(false);
    //                 }
    //                 setShowSendOtpError(true);
    //             }
    //         } else {
    //             verifyOtpFunction("MSISDN");
    //         }
    //     }
    // };

    // const sendOtpFunction = async (type: String) => {
    //     if (!executeRecaptcha) {
    //         throw new Error("sendOtpFunction - reCAPTCHA hasn't loaded yet");
    //     }

    //     const recaptchaToken = await executeRecaptcha("sendOTP");

    //     const bodyRequest = {
    //         receiver: mobileNumber,
    //         type: type,
    //         lang: getLanguage(),
    //         recaptchaToken: recaptchaToken,
    //     };

    //     const response = await post<IBooleanResponse>(sendOtp(), {
    //         body: bodyRequest,
    //         isSecured: keycloakUtils.isAuthenticated(),
    //         forwardError: true,
    //     });

    //     if (!response?.result) {
    //         throw new Error("sendOtpFunction - OTP was not sent");
    //     }

    //     if (type === "MSISDN") {
    //         setVerifyNumberText(verifyOTPTranslated);
    //         setShowSendOtpError(false);
    //     }
    // };

    // const verifyOtpFunction = (type: string) => {
    //     const bodyVerifyRequest = {
    //         receiver: mobileNumber,
    //         otp: OTP,
    //         type: type,
    //     };

    //     post<IBooleanResponse>(sendOtp() + "/verify", {
    //         body: bodyVerifyRequest,
    //         isSecured: keycloakUtils.isAuthenticated(),
    //     }).then((response) => {
    //         if (response?.result) {
    //             if (type === "MSISDN") {
    //                 setNumberVerified(true);
    //                 setVerifyNumberText(verifyNumberTranslated);
    //                 setShowNumerOtpError(false);
    //                 setShowSendOtpError(false);
    //             }
    //         } else {
    //             if (type === "MSISDN") {
    //                 setShowNumerOtpError(true);
    //             }
    //         }
    //     });
    // };

    const validatePhoneNumber = (number: string) => {
        if (isAuthenticated) {
            setIsPhoneValid(true);
        } else {
            let error: string | undefined = undefined;

            try {
                const num = "+".concat(number);
                if (!phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(num))) {
                    error = t("portin:phoneNumberError");
                } else if (portInNumbers.length && !portInNumbers.includes(number)) {
                    error = t("customerDetails:portinNumberError");
                }
            } catch (e: any) {
                error = e.message;
            }

            error?.length ? setIsPhoneValid(false) : setIsPhoneValid(true);
            return error;
        }
    };

    return (
        <section>
            <Grid className="customer-form__title" container justify="center" spacing={2}>
                <Grid item md={5} xs={12}>
                    <Typography color="primary" variant="h2">
                        {t("customerDetails:personalDetails")}
                    </Typography>
                </Grid>
                <Grid item md={10} xs={12}>
                    <Typography variant="body1">
                        {t("customerDetails:personalDetailsInfo")}
                        <Link
                            color="secondary"
                            href={`${WORDPRESS_URL}/${getLanguage()}/privacy`}
                            rel="noopener"
                            target="_blank"
                            underline="always"
                        >
                            <b>{t("customerDetails:privacyPolicy")}</b>
                        </Link>
                        {t("customerDetails:ofGomo")}
                    </Typography>
                </Grid>
            </Grid>
            <FormGroup className="customer-form-fields" row>
                <Grid className="customer-form-fields" container>
                    <Grid item md={6} sm={5} xs={12}>
                        <TextField
                            className="xtest_firstname_input"
                            disabled={isAuthenticated}
                            error={Boolean(errors.firstName)}
                            helperText={errors.firstName?.message}
                            id="firstname"
                            inputRef={register({
                                required: t("validation:required"),
                                validate: specialAlphaNumericRegex,
                            })}
                            label={`${t("customerDetails:firstName")} *`}
                            margin="dense"
                            style={{ width: "90%" }}
                            name="firstName"
                            type="text"
                        />
                    </Grid>
                    <Grid item md={6} sm={5} xs={12}>
                        <TextField
                            className="xtest_lastname_input"
                            disabled={isAuthenticated}
                            error={Boolean(errors.lastName)}
                            helperText={errors.lastName ? errors.lastName.message : undefined}
                            id="surname"
                            inputRef={register({
                                required: t("validation:required"),
                                validate: specialAlphaNumericRegex,
                            })}
                            label={`${t("customerDetails:surname")} *`}
                            margin="dense"
                            style={{ width: "90%" }}
                            name="lastName"
                            type="text"
                        />
                    </Grid>
                </Grid>
            </FormGroup>
            <FormGroup className="customer-form-fields" row>
                <Grid className="customer-form-fields" container alignItems="center" direction={"row"} spacing={1}>
                    <Grid item md={4} xs={12}>
                        <Controller
                            control={control}
                            name="mobileNumber"
                            render={(controllerProps) => (
                                <PhoneInput
                                    // onlyCountries={["cy", "gr"]}
                                    country={"cy"}
                                    preferredCountries={["cy"]}
                                    disabled={isAuthenticated}
                                    countryCodeEditable={false}
                                    localization={getLanguage() === "el" ? gr : undefined}
                                    enableSearch={true}
                                    value={controllerProps.value}
                                    specialLabel={`${t("customerDetails:contactNumber")} *`}
                                    searchPlaceholder={t("customerDetails:searchCountry")}
                                    searchNotFound={t("customerDetails:noCountryFound")}
                                    onChange={(phone: any, data: CountryData) => {
                                        onMobileNumberChange(phone);
                                        controllerProps.onChange(phone);
                                    }}
                                    isValid={() => {
                                        return isPhoneValid;
                                    }}
                                />
                            )}
                            rules={{
                                required: t("validation:required"),
                                validate: (val: string) => validatePhoneNumber(val),
                            }}
                        />
                        {errors.mobileNumber && (
                            <Typography color="error" variant="body2">
                                {errors.mobileNumber.message}
                            </Typography>
                        )}
                    </Grid>
                    {/* {verifyNumberText === verifyOTPTranslated && (
                        <Grid item md={3} xs={12}>
                            <TextField
                                className="xtest_mobilenumber_input"
                                label={`${t("customerDetails:enterOTP")} *`}
                                value={OTP}
                                margin="dense"
                                name="OTP"
                                style={{ width: "80%" }}
                                type="text"
                                onChange={(event) => {
                                    setOTP(event.target.value);
                                }}
                            />
                            <Typography color="textSecondary" gutterBottom id="mobileOtpHelper" variant="body2">
                                {t("customerDetails:mobileOtpHelper")}
                            </Typography>
                            {showNumerOtpError && (
                                <Typography color="error" variant="body2">
                                    {t("portin:invalidOTP")}
                                </Typography>
                            )}
                        </Grid>
                    )} */}
                    {/* {!numberVerified && (
                        <Grid item md={2} xs={12}>
                            {isValidateLoading && <Loader size={40} />}
                            {!isValidateLoading && (
                                <Button
                                    disabled={
                                        !mobileNumber ||
                                        (verifyNumberText === verifyNumberTranslated && !emailVerified) ||
                                        (verifyNumberText === verifyOTPTranslated && !OTP)
                                    }
                                    color="primary"
                                    type="button"
                                    variant="contained"
                                    onClick={() => {
                                        onVerifyNumberButtonClick(false);
                                    }}
                                >
                                    {verifyNumberText}
                                </Button>
                            )}

                            {showSendOtpError && (
                                <Typography color="error" variant="body2">
                                    {t("validation:sendOTPFailed")}
                                </Typography>
                            )}
                            {!emailVerified && verifyNumberText === verifyNumberTranslated && (
                                <Typography color="textSecondary" variant="body2">
                                    {t("customerDetails:verifyEmailFirst")}
                                </Typography>
                            )}
                        </Grid>
                    )}
                    {showNumerOtpError && (
                        <Grid item md={2} xs={12}>
                            <Button
                                color="primary"
                                type="button"
                                variant="contained"
                                onClick={() => {
                                    onVerifyNumberButtonClick(true);
                                }}
                            >
                                {t("portin:resendOTP")}
                            </Button>
                        </Grid>
                    )} */}
                </Grid>
            </FormGroup>
            <FormGroup row>
                <Grid className="customer-form-fields" container spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <Controller
                            control={control}
                            name="birthDate"
                            render={(controllerProps) => (
                                <TextField
                                    InputLabelProps={{ shrink: Boolean(birthDate) }}
                                    InputProps={{
                                        inputComponent: DateMask,
                                    }}
                                    className="xtest_birthdate_input"
                                    disabled={isAuthenticated}
                                    error={Boolean(errors.birthDate)}
                                    helperText={errors.birthDate?.message}
                                    inputRef={controllerProps.ref}
                                    label={`${t("customerDetails:dateBirth")} *`}
                                    margin="normal"
                                    name={controllerProps.name}
                                    type="text"
                                    value={controllerProps.value}
                                    onChange={controllerProps.onChange}
                                    fullWidth
                                />
                            )}
                            rules={{
                                required: t("validation:required"),
                                validate: (value: string) =>
                                    dateFormatRegex(value) ??
                                    over18Valid(value) ??
                                    minYearValid(value) ??
                                    maxYearValid(value),
                            }}
                        />
                        <Typography color="textSecondary" id="birthDateFormat" variant="body2">
                            {t("customerDetails:format")}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            className="xtest_identificationNumber_input"
                            disabled={isAuthenticated}
                            error={Boolean(errors.identificationNumber)}
                            helperText={errors.identificationNumber ? errors.identificationNumber.message : undefined}
                            id="identificationNumber"
                            inputRef={register({
                                required: t("validation:required"),
                            })}
                            label={`${t("customerDetails:identificationNumber")} *`}
                            margin="normal"
                            name="identificationNumber"
                            type="text"
                            fullWidth
                        />
                        <Typography color="textSecondary" gutterBottom id="identificationNumberHelper" variant="body2">
                            {t("customerDetails:identificationNumberHelper")}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <CommunicationLanguageRadio control={control} fieldsDisabled={isAuthenticated} />
                    </Grid>
                    {!isAuthenticated && (
                        <Grid item container xs={12} spacing={1}>
                            <Grid item xs={12}>
                                <Typography color="textSecondary" gutterBottom variant="body2">
                                    {t("customerDetails:keepMeUpdated")}
                                    <Link
                                        color="inherit"
                                        href={`${WORDPRESS_URL}/${getLanguage()}/help-support/`}
                                        rel="noopener"
                                        target="_blank"
                                        underline="always"
                                    >
                                        {t("customerDetails:here")}
                                    </Link>
                                </Typography>
                            </Grid>
                            <Grid item xs={7} sm={3}>
                                <Controller
                                    control={control}
                                    name={"permissions"}
                                    rules={{
                                        required: t("validation:required"),
                                    }}
                                    render={(renderProps) => (
                                        <TextField
                                            fullWidth
                                            id="permissions"
                                            inputRef={renderProps.ref}
                                            label={`${t("customerDetails:pleaseSelect")} *`}
                                            name="permissions"
                                            select
                                            value={renderProps.value}
                                            onChange={(event) => {
                                                return renderProps.onChange(event);
                                            }}
                                            error={Boolean(errors?.permissions?.message)}
                                            helperText={errors?.permissions?.message}
                                        >
                                            {permissions.map((permission, key) => (
                                                <MenuItem key={key} value={permission.value}>
                                                    {t(`customerDetails:${permission.label}` as any)}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}
                                />
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </FormGroup>
        </section>
    );
};
